import { FC } from 'react';
import { ITalentAssetsProps } from 'shared/interfaces/ITalent';
import InfoViewModal from 'components/MyInfo/InfoViewModal/InfoViewModal';
import { PropsIcon } from '@room-match/shared-ui-components';

type AssetsPropsViewModalProps = {
  data: ITalentAssetsProps;
  openDialog: boolean;
  handleDialog: VoidFunction;
};

const AssetsPropsViewModal: FC<AssetsPropsViewModalProps> = ({ data, openDialog, handleDialog }) => {
  const infoViewDetailsData = [
    { name: 'Item', details: data?.item },
    { name: 'Type', details: data?.type },
    { name: 'Images', details: data?.image_count?.toString() },
  ];
  const infoViewImageData = data?.attached_media;
  return (
    <InfoViewModal
      headerIcon={<PropsIcon fontSize="inherit" />}
      openDialog={openDialog}
      handleDialog={handleDialog}
      infoViewDetailsData={infoViewDetailsData}
      infoViewImageData={infoViewImageData}
      title="Assets / Props"
    />
  );
};

export default AssetsPropsViewModal;
